/**
 * Purchase Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PurchaseOrder } from './purchaseOrder';
import { PurchaseRequestItemResultDTO } from './purchaseRequestItemResultDTO';


export interface PurchaseRequestResultDTO { 
    id?: number;
    title?: string;
    series?: string;
    scheduleDate?: string;
    deleteFlag?: boolean;
    creationDate?: string;
    lastUpdateDate?: string;
    createdBy?: string;
    lastUpdatedBy?: string;
    objectVersionNumber?: number;
    status?: PurchaseRequestResultDTO.StatusEnum;
    items?: Array<PurchaseRequestItemResultDTO>;
    orders?: Array<PurchaseOrder>;
}
export namespace PurchaseRequestResultDTO {
    export const StatusEnum = {
        Pending: 'PENDING',
        Rejected: 'REJECTED',
        Approved: 'APPROVED'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


